export type User = {
  id: string;
  username: string;
};

/** TODO */
export enum ScheduleDirection {
  PickUp = "pick_up",
}

export enum BusAttendanceStatus {
  Completed = "completed",
}

export type BusAttendance = {
  busAttendanceId: string;
  busRoute: string;
  busName: string;
  profilePicture: string;
  scheduleDirection: ScheduleDirection;
  status: BusAttendanceStatus;
  startedAt: string;
  completedAt: string;
  busAttendant: {
    id: string;
    name: string;
  };
  busDriver: {
    id: string;
    name: string;
  };
  location: {
    latitude: string;
    longitude: string;
  };
};

export type Location = {
  id: string;
  busAttendanceId: string;
  lat: number;
  lng: number;
  timestamp: number;
  accuracy?: number;
  speed?: number;
  heading?: number;
};

export type DetailedLocation = {
  index: number;
  startedAt: number;
  endedAt: number;
  isStop: boolean;
  children: Array<ChildData>;
} & Location;

export type LatLng = {
  lat: number;
  lng: number;
};

export type BoundingBox = {
  northEast: LatLng;
  southWest: LatLng;
};

export enum BusAttendanceChildStatus {
  PickedUp = "picked_up",
}

export type ChildData = {
  id: string;
  fname: string;
  lname: string;
  age: string;
  parentEmail: string;
  nfcCardUid: string;
  classTeacher: string;
  profilePicture: string;
  father: {
    name: string;
    phone: string;
  };
  mother: {
    name: string;
    phone: string;
  };
  home: {
    phone: string;
    address: string;
    latitude: string;
    longitude: string;
  };
  class: {
    id: string;
    name: string;
  };
  branch: {
    id: string;
    name: string;
    color: string;
  };
  status: BusAttendanceChildStatus;
  time: string;
  location: {
    latitude: string;
    longitude: string;
  };
};
